<template>

  <div class="height-100">
    <Unavailable
      v-if="unavailable"
      title="Importação e exportação"
      class="height-100" />

    <div
      v-if="!unavailable"
      class="vflex">
      <div class="vflex-row-0 pt-3">
        <ul class="nav nav-tabs px-3">
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: type === 'export' }"
              @click="setType('export')"
              href="javascript:void(0)">{{ $t('Export') }}</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: type === 'import' }"
              @click="setType('import')"
              href="javascript:void(0)">{{ $t('Import') }}</a>
          </li>
        </ul>
      </div>

      <div class="vflex-row-0 vflex-header p-3">
        <div class="page-title">
          <div class="title">
            <h4>{{ type === 'import' ? $t('Import') : $t('Export') }}</h4>
          </div>
          <div class="btn-row">
            <button
              v-if="type === 'export'"
              type="button"
              class="btn btn-light"
              @click="showModal('export')">
              {{ $t('Export') }}
            </button>
            <button
              v-if="type === 'import'"
              type="button"
              class="btn btn-light"
              @click="showModal('import')">
              {{ $t('Import') }}
            </button>
          </div>
        </div>
      </div>

      <div class="vflex-row-1">
        <DataimexModalImport
          v-if="modal === 'import'"
          @hideModal="showModal(null)"
          @saved="refresh" />
        <DataimexModalExport
          v-if="modal === 'export'"
          @hideModal="showModal(null)"
          @saved="refresh" />

        <Paginaty
          :total="paginate.total"
          :pages="paginate.pages"
          :page="paginate.page"
          :creating="creating"
          :loading="loading"
          @changePage="loadData">
          
          <template slot="content">
            <table class="table">
              <thead>
                <tr>
                  <th>{{ $t('Entity') }}</th>
                  <th>{{ $t('Status') }}</th>
                  <th>{{ $t('Size') }}</th>
                  <th>{{ $t('Author') }}</th>
                  <th>{{ $t('Created at') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <DataimexItem
                  v-for="(item, index) in dataimexs"
                  :key="index"
                  :value="item"
                  @removed="loadData" />
              </tbody>
            </table>
          </template>

          <template slot="noresults">
            {{ $t('There are no items') }}
          </template>

        </Paginaty>

      </div>
    </div>
  </div>

</template>

<script>
import Paginaty from '@/components/Paginaty/Paginaty'
import DataimexItem from './DataimexItem'
import DataimexModalExport from './DataimexModalExport'
import DataimexModalImport from './DataimexModalImport'
import Unavailable from '../Unavailable/Unavailable'

export default {
  name: 'Dataimex',
  components: {
    Paginaty,
    DataimexItem,
    DataimexModalExport,
    DataimexModalImport,
    Unavailable
  },
  data () {
    return {
      unavailable: false,
      type: 'export',
      creating: true,
      loading: true,
      filters: {},
      sort: '-created_at',
      modal: null
    }
  },
  computed: {
    dataimexs () {
      return this.$store.getters.getDataimexs
    },
    paginate () {
      return this.$store.getters.getDataimexsPaginate
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    setType (val) {
      this.type = val
      this.loadData()
    },
    showModal (val) {
      this.modal = val
    },
    refresh () {
      this.showModal(null)
      this.loadData()
    },
    loadData (page = 1) {
      this.loading = true

      const params = {
        ...this.filters,
        type: this.type,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectDataimexs', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      }).catch(err => {
        this.unavailable = err.response && err.response.data && err.response.data.name === 'UpgradeRequired'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dataimex/Dataimex.vue